import $ from 'jquery';

$(document).ready(function () {
  acfExampleBlock();
});

function acfExampleBlock() {
  $('.js-acf-example-block').each(function () {});
}
